import React from 'react';
import ReactModal from 'react-modal';
import { RegularButton, CommonInput, TextAreaInput, FormErrorWrap, AlertAdapter } from 'pg-ui-library';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { phoneRegExp } from 'src/utils/phoneRegex';
import { useTranslation } from 'react-i18next';
import CompanyService from 'src/services/company.services';
import {
  CompanyAdditionBody,
  CompanyAdditionForm,
  CompanyAdditionHeader,
  CompanyAdditionFormRow,
  CompanyAdditionForm1Row,
  CompanyAdditionFormRowleft,
  CompanyAdditionFormRowLast,
} from './styles';

interface AddCompaniesProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const validationSchema = yup.object().shape({
  email: yup.string().email(),
  phone: yup.string().max(14).matches(phoneRegExp, 'phone'),
});
const AddCompanies: React.FC<AddCompaniesProps> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: {
      legalEntityId: '',
      name: '',
      state: '',
      city: '',
      country: '',
      county: '',
      zipCode: '',
      phone: '',
      email: '',
      addressDescription: '',
      fullPrimaryAddress: '',
      identificationNumber: '',
      nameAlias: '',
    },
    validationSchema,
    onSubmit: async values => {
      try {
        await CompanyService.createCompany(values);
        AlertAdapter('Company has created!', 'success');
        onRequestClose();
      } catch (error: any) {
        const errormsg = error?.toString() || 'An error occurred while creating the company';
        AlertAdapter(errormsg, 'error');
      }
    },
  });

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '60%',
          height: '600px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 20px 0 20px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <CompanyAdditionHeader>
        <div>
          <h3>{t('settings.title.Company')}</h3>
        </div>
        <div style={{ marginTop: '30px' }}>
          <CloseIcon src={closeSvg} onClick={onRequestClose} />
        </div>
      </CompanyAdditionHeader>
      <CompanyAdditionForm onSubmit={formik.handleSubmit}>
        <CompanyAdditionBody>
          <CompanyAdditionForm1Row>
            <CommonInput
              id="legalEntityId"
              name="legalEntityId"
              label="Company ID"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('legalEntityId', e.target.value)}
            />
            <CommonInput
              id="name"
              name="name"
              label="Company Name"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('name', e.target.value)}
            />
            <CommonInput
              id="state"
              name="state"
              label="State"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('state', e.target.value)}
            />
            <CommonInput
              id="Field 1"
              name="city"
              label="City"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('city', e.target.value)}
            />
            <CommonInput
              id="country"
              name="country"
              label="Country"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('country', e.target.value)}
            />
          </CompanyAdditionForm1Row>
          <CompanyAdditionFormRow>
            <CommonInput
              id="zipCode"
              name="zipCode"
              label="Zip Code"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('zipCode', e.target.value)}
            />
            {/* <FormErrorWrap visible errorMessage={formik.errors.zipCode || ''} /> */}
            <CommonInput
              id="phone"
              name="phone"
              label="Phone"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('phone', e.target.value)}
            />
            <CommonInput
              id="email"
              name="email"
              label="Email"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('email', e.target.value)}
            />
            <FormErrorWrap visible errorMessage={formik.errors.email || ''} />
            <TextAreaInput
              id="addressDescription"
              name="addressDescription"
              label="Address Description"
              placeholder="Type here..."
              rows={5}
              cols={40}
              onChange={e => formik.setFieldValue('addressDescription', e.target.value)}
            />
          </CompanyAdditionFormRow>
          <CompanyAdditionFormRowleft>
            <CommonInput
              id="fullPrimaryAddress"
              name="fullPrimaryAddress"
              label="Address"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('fullPrimaryAddress', e.target.value)}
            />
            <CommonInput
              id="identificationNumber"
              name="identificationNumber"
              label="Identification Number"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('identificationNumber', e.target.value)}
            />
            <CommonInput
              id="nameAlias"
              name="nameAlias"
              label="Name Alias"
              placeholder="Type here..."
              onChange={e => formik.setFieldValue('nameAlias', e.target.value)}
            />
          </CompanyAdditionFormRowleft>
          <CompanyAdditionFormRowLast>
            <RegularButton type="submit">{t('settings.submit.button')}</RegularButton>
          </CompanyAdditionFormRowLast>
        </CompanyAdditionBody>
      </CompanyAdditionForm>
    </ReactModal>
  );
};
export default AddCompanies;
